import { render } from "./ArtifactInfoArea.vue?vue&type=template&id=af4fba16&scoped=true"
import script from "./ArtifactInfoArea.vue?vue&type=script&lang=js"
export * from "./ArtifactInfoArea.vue?vue&type=script&lang=js"

import "./ArtifactInfoArea.vue?vue&type=style&index=0&id=af4fba16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af4fba16"]])

export default __exports__